import { createSlice } from "@reduxjs/toolkit";

export const shopSlice = createSlice({
  name: "Shop",
  initialState: {
    books: [
      // {
      //     bookId: 11,
      //     title: 'Coming Clean',
      //     author: 'Rutherford Jonassey',
      //     priceA: 28,
      //     priceB: 25,
      //     priceC: 19,
      //     rating: 3,
      //     reviews: ['This Book is Amazing', 'Very Good', 'I will definitely Promote this Book', 'This Influenced me a lot'],
      //     cover: 'http://54.172.169.122/wp-content/uploads/2020/06/imgpsh_fullsize_anim-15.png'
      // },
      // {
      //     bookId: 12,
      //     title: 'Migrant Journey To Marine',
      //     author: 'John M. Howard',
      //     priceA: 35,
      //     priceB: 30,
      //     priceC: 26,
      //     rating: 3,
      //     reviews: [],
      //     cover: 'http://54.172.169.122/wp-content/uploads/2020/06/imgpsh_fullsize_anim-16.png'
      // },
      // {
      //     bookId: 13,
      //     title: 'Paper Jump Suit',
      //     author: 'Brown H. Hamsey',
      //     priceA: 20,
      //     priceB: 17,
      //     priceC: 15,
      //     rating: 3,
      //     reviews: [],
      //     cover: 'http://54.172.169.122/wp-content/uploads/2020/06/imgpsh_fullsize_anim-14.png'
      // },
    ],
    cart: [],

    currentBook: {},
    notification: {
      open: false,
      message: "",
    },
  },
  reducers: {
    fetchBooks: (state, action) => {
      // console.log({'Fetch Books Action Payload': action.payload})
      state.books = action.payload;
    },
    addToCart: (state, action) => {},
    addReview: (state, action) => {},

    updateCart: (state, action) => {},
  },
});

export const { addToCart, addReview, updateCart, fetchBooks } =
  shopSlice.actions;
export default shopSlice.reducer;
